module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.8073480b.mp3";